/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProductsJswStorageManagementType from '@jira/spa-apps__admin-pages-products-jsw-storage-management/src/ProductsJswStorageManagementType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProductsJswStorageManagement: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ProductsJswStorageManagementType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-products-jsw-storage-management", jiraSpaEntry: "async-products-jsw-storage-management" */ '@jira/spa-apps__admin-pages-products-jsw-storage-management/src/ProductsJswStorageManagementType.tsx'
			),
		),
	);

const AsyncProductsJswStorageManagement = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJswStorageManagement}
		pageId="products-jsw-storage-management"
		shouldShowSpinner
	/>
);

export default AsyncProductsJswStorageManagement;
